<template>
  <div id="main" class="productCenter">
    <topNav></topNav>
    <div class="inner" v-if="showNav.Big == 'DA' && showNav.small == 'a1'">
      <div class="demobox bigNav">
      <el-carousel trigger="click" class="bannerMain" v-show="banners.length>1">
        <el-carousel-item v-for="(item,index) in banners" :key="index">
          <div class="bigNav-img">
            <img :src="item" class="bigNav-img" alt="" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <img :v-show="banners.length<=1" :src="banners[0]" class="bigNav-img" alt="" />
      </div>
      <div class="demobox banner bannera1" id="bannera1">
        <div class="wenzi">
          <a @click="tiaozhaung('大德火箭周报')">大德火箭周报</a>
          <a @click="tiaozhaung('主题策略')">主题策略</a>
        </div>
      </div>
      <div class="demobox smallNav" id="bannera2">
        <img
          src="../common/images/productCenter/A1/A126812@3x.png"
          class="bigNav-img"
          alt=""
          style="width: 1920px;"
        />
        <div class="wenzi2">
          <a @click="tiaozhaung('stockUniverse')">股宇宙数据库</a>
          <a @click="tiaozhaung('鲲算AI选股')">鲲算AI选股</a>
          <a @click="tiaozhaung('财富在线')">财富在线</a>
        </div>
      </div>
      <div class="demobox smallNav" id="bannera3">
        <img
          src="../common/images/productCenter/A1/26819(2).png"
          class="bigNav-img"
          alt=""
        />
        <div class="wenzi shift">
          <a @click="tiaozhaung('交易师')">交易师</a>
          <!-- <a>德财商学院</a> -->
        </div>
        <!-- <div class="zbbox">
          <div class="zblongbox">
            <div class="zb_l">
              <div class="text">
                <p>
                  大德周报由专业投研团队对市场热点题材和板块进行分类整合寻觅投资机会，专注市场热门品种，传递市场短线投资价值。
                </p>
                <p>
                  从专业、专心及专研出发，是中国股市证券投资者必备的证券资讯产品。
                </p>
              </div>
              <img
                class="linebtn"
                src="@/common/images/productCenter/A1/b1791.png"
                alt=""
              />
              <div class="icons">
                <img src="@/common/images/productCenter/A1/icon1.png" alt="" />
                <img src="@/common/images/productCenter/A1/z172.png" alt="" />
                <img src="@/common/images/productCenter/A1/icon2.png" alt="" />
                <img src="@/common/images/productCenter/A1/z172.png" alt="" />
                <img src="@/common/images/productCenter/A1/icon3.png" alt="" />
                <img src="@/common/images/productCenter/A1/z172.png" alt="" />
                <img src="@/common/images/productCenter/A1/icon4.png" alt="" />
              </div>
              <div class="icontext">
                <span>热门个股</span>
                <span>短线操作</span>
                <span>快进快出</span>
                <span>仓位建议</span>
              </div>
            </div>
            <div class="zb_r">
              <img src="@/common/images/productCenter/A1/b1961.png" alt="" />
            </div>
          </div>
        </div> -->
      </div>
      <div class="demobox px smallNav" id="bannera4">
        <img
          src="../common/images/productCenter/A1/26817.png"
          class="bigNav-img"
          alt=""
        />
        <div class="wenzi tougu" style="color: #dfb283">
          <a @click="tiaozhaung('大德精研')">大德精研</a>
          <a @click="tiaozhaung('大德专属')">大德专属</a>
          <a @click="tiaozhaung('investTeam')">投顾服务</a>
        </div>
        <!-- <div class="boxin">
          <div class="title" style="margin-bottom: 30px">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>产品亮点</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b">大德周报，为您打造</div>
          </div>
          <div class="cars">
            <div class="car">
              <div class="carLine"></div>

              <div class="car_l">
                <img src="@/common/images/productCenter/A1/car1.png" alt="" />
              </div>
              <div class="car_r" style="margin-top: 50px">
                <p>智能盯盘，实时跟踪个股变化</p>
                <p>盘中策略提示，及时把握机会</p>
              </div>
            </div>
            <div class="car">
              <div class="carLine"></div>
              <div class="car_l">
                <img src="@/common/images/productCenter/A1/car2.png" alt="" />
              </div>
              <div class="car_r" style="margin-top: 50px">
                <p>热门个股，短线操作</p>
                <p>快进快出，仓位建议</p>
              </div>
            </div>
            <div class="car">
              <div class="carLine"></div>

              <div class="car_l">
                <img src="@/common/images/productCenter/A1/car3.png" alt="" />
              </div>
              <div class="car_r" style="margin-top: 50px">
                <p>详细买入/止盈/止损区间提示</p>
                <p>个股操盘动态解析，智能云端APP推送</p>
              </div>
            </div>
            <div class="car">
              <div class="carLine"></div>

              <div class="car_l">
                <img src="@/common/images/productCenter/A1/car4.png" alt="" />
              </div>
              <div class="car_r" style="margin-top: 50px">
                <p>中国股市证券投顾报告</p>
                <p>每周个股动态与操盘心得</p>
              </div>
            </div>
            <div class="car">
              <div class="carLine"></div>

              <div class="car_l">
                <img src="@/common/images/productCenter/A1/car5.png" alt="" />
              </div>
              <div class="car_r" style="margin-top: 50px">
                <p>证券市场研究月报</p>
                <p>每月精选个股与持仓建议</p>
              </div>
            </div>
            <div class="car">
              <div class="carLine"></div>

              <div class="car_l">
                <img src="@/common/images/productCenter/A1/car6.png" alt="" />
              </div>
              <div class="car_r" style="margin-top: 50px">
                <p>交易师（周报投教）</p>
                <p style="width: 364px">专业投顾亲授投资技巧与实战经验</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- <div class="demobox look10"> -->
      <!-- <div class="look10box">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>十大必看理由</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b">热点追击，交易逐利</div>
          </div>
          <div class="cara1">
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca1.png" alt="" />
              <p class="cara11p1">智能云计算</p>
              <p class="cara11p2">人工智能帮您盯盘</p>
            </div>
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca2.png" alt="" />
              <p class="cara11p1">实时监控资金流向</p>
              <p class="cara11p2">帮您快速挖掘资金新宠</p>
            </div>
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca3.png" alt="" />
              <p class="cara11p1">追踪热点</p>
              <p class="cara11p2">帮您掌握资金风向</p>
            </div>
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca4.png" alt="" />
              <p class="cara11p1">紧跟市场情绪</p>
              <p class="cara11p2">帮您精选短线优股</p>
            </div>
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca5.png" alt="" />
              <p class="cara11p1">盘中热点实时更新</p>
              <p class="cara11p2">帮您迅速寻找交易机会</p>
            </div>
          </div>
          <div class="cara1">
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca6.png" alt="" />
              <p class="cara11p1">实时解盘</p>
              <p class="cara11p2">帮您盘中资讯实时解析</p>
            </div>
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca7.png" alt="" />
              <p class="cara11p1">《交易师》独家课程</p>
              <p class="cara11p2">教学课程帮您提升自身专业能力</p>
            </div>
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca8.png" alt="" />
              <p class="cara11p1">证券市场研究</p>
              <p class="cara11p2">帮您理清投资方向，提升投资能力</p>
            </div>
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca9.png" alt="" />
              <p class="cara11p1">专业投顾团队</p>
              <p class="cara11p2">相信团队专业的力量</p>
            </div>
            <div class="cara11">
              <img src="@/common/images/productCenter/A1/ca10.png" alt="" />
              <p class="cara11p1">23年证券投顾服务</p>
              <p class="cara11p2">专业、稳健、研究</p>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
    </div>
    <div class="inner" v-if="showNav.Big == 'DA' && showNav.small == 'a2'">
      <div class="demobox bigNav">
        <div class="boxin bigNavbox">
          <div
            class="NavD zx"
            v-on:click="BigNav('DA')"
            :class="showNav.Big == 'DA' ? 'isBnav' : ''"
          >
            <span>资讯产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DB')"
            :class="showNav.Big == 'DB' ? 'isBnav' : ''"
          >
            <span>投顾产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DC')"
            :class="showNav.Big == 'DC' ? 'isBnav' : ''"
          >
            <span>数据产品</span>
          </div>
        </div>
      </div>
      <div class="demobox banner bannera2">
        <div class="boxin banmain">
          <img src="@/common/images/productCenter/A2/banner.png" alt="" />
        </div>
      </div>
      <div class="demobox smallNav">
        <div class="boxin smallNavbox smallNavbox2">
          <div
            class="Navd zb"
            v-on:click="SmaNav('a1')"
            :class="showNav.small == 'a1' ? 'isSnav' : ''"
          >
            大德周报
          </div>
          <div
            class="Navd zg"
            v-on:click="SmaNav('a2')"
            :class="showNav.small == 'a2' ? 'isSnav' : ''"
          >
            人工诊股
          </div>
          <div
            class="Navd cl"
            v-on:click="SmaNav('a3')"
            :class="showNav.small == 'a3' ? 'isSnav' : ''"
          >
            主题策略
          </div>
        </div>
      </div>
      <div class="demobox">
        <div class="zgbox">
          <div class="zglongbox">
            <div class="zg_l">
              <div class="text">
                <p>
                  人工诊股由专业投顾为股票把脉，系统并科学分析上市公司经营环境、发展前景及投资价值等，提供全面、客观的短期与中长期专业投顾分析。
                </p>
              </div>
              <div class="zg_1 zg_11">
                <img src="@/common/images/productCenter/A2/b1846.png" alt="" />
                <p>优势：投资顾问亲自诊断分析股票，多一份温度</p>
              </div>
              <div class="zg_1 zg_12">
                <img src="@/common/images/productCenter/A2/b1845.png" alt="" />
                <p>特点：结合行情及时诊断，提供最新价值参考</p>
              </div>
              <p class="zgts">人工诊股提供的价值：</p>
              <div class="zgicons">
                <img src="@/common/images/productCenter/A2/b1847.png" alt="" />
                <img src="@/common/images/productCenter/A2/z85.png" alt="" />
                <img src="@/common/images/productCenter/A2/b1847.png" alt="" />
                <img src="@/common/images/productCenter/A2/z85.png" alt="" />
                <img src="@/common/images/productCenter/A2/b1847.png" alt="" />
              </div>
              <div class="zgtext">
                <span>全方位解析您的个股</span>
                <span>剖析后市机会</span>
                <span>专业投资顾问给您支招</span>
              </div>
            </div>
            <div class="zg_r">
              <img src="@/common/images/productCenter/A2/b1961.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="demobox zgld">
        <div class="boxin">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>诊股亮点</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b">多维度解析未来走势</div>
          </div>
          <div class="cards">
            <div class="card card1">
              <p>
                财富在线投顾团队穿越牛熊，别具慧眼，可线上选择您喜欢的投资顾问为您的股票把脉！
              </p>
            </div>
            <div class="card card2">
              <p>
                基本面、资金面、技术面全方位提供专业判断，附有短中长周期详细的投顾分析！
              </p>
            </div>
            <div class="card card3">
              <p>
                专业且高效地提供个股诊断结果，是保持财富在线投顾团队始终走在价值前沿的信条！
              </p>
            </div>
            <div class="card card4">
              <p>注册成为财富在线用户，免费体验！</p>
            </div>
          </div>
        </div>
      </div>
      <div class="demobox tyrgzg">
        <div class="boxin">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>体验人工诊股</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b">多维度解析未来走势</div>
          </div>
          <div class="bline">
            <img src="../common/images/productCenter/A2/b1.png" alt="" />
            <img src="../common/images/productCenter/A2/bline1.png" alt="" />
            <img src="../common/images/productCenter/A2/b2.png" alt="" />
            <img src="../common/images/productCenter/A2/bline1.png" alt="" />
            <img src="../common/images/productCenter/A2/b3.png" alt="" />
          </div>
          <div class="btext">
            <span style="margin-left: 99px">扫码下载财富在线</span>
            <span style="margin-left: 213px">风险测评</span>
            <span style="margin-left: 248px">体验人工诊股</span>
          </div>
          <img
            class="b1860"
            src="../common/images/productCenter/A2/b1860.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="inner" v-if="showNav.Big == 'DA' && showNav.small == 'a3'">
      <div class="demobox bigNav">
        <div class="boxin bigNavbox">
          <div
            class="NavD zx"
            v-on:click="BigNav('DA')"
            :class="showNav.Big == 'DA' ? 'isBnav' : ''"
          >
            <span>资讯产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DB')"
            :class="showNav.Big == 'DB' ? 'isBnav' : ''"
          >
            <span>投顾产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DC')"
            :class="showNav.Big == 'DC' ? 'isBnav' : ''"
          >
            <span>数据产品</span>
          </div>
        </div>
      </div>
      <div class="demobox banner bannera3">
        <div class="boxin banmain">
          <img src="@/common/images/productCenter/A3/banner.png" alt="" />
        </div>
      </div>
      <div class="demobox smallNav">
        <div class="boxin smallNavbox">
          <div
            class="Navd zb"
            v-on:click="SmaNav('a1')"
            :class="showNav.small == 'a1' ? 'isSnav' : ''"
          >
            大德周报
          </div>
          <div
            class="Navd zg"
            v-on:click="SmaNav('a2')"
            :class="showNav.small == 'a2' ? 'isSnav' : ''"
          >
            人工诊股
          </div>
          <div
            class="Navd cl"
            v-on:click="SmaNav('a3')"
            :class="showNav.small == 'a3' ? 'isSnav' : ''"
          >
            主题策略
          </div>
        </div>
      </div>
      <div class="demobox cpld">
        <div class="boxin">
          <div class="title" style="margin-top: 13px">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>产品亮点</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b">
              深度剖析
              <span style="display: inline-block; width: 20px"></span>
              把控先机
            </div>
          </div>
          <div class="cpld_mid">
            投顾团队掌舵，研判市场风口动向，先人一步拔得头筹。审时度势，进退有序，攻防一体。
          </div>
          <!-- <div class="cpld_line">
            <hr />
            <span></span>
            <hr />
          </div> -->
          <div class="cpld_s">
            <div class="cpld1">
              <img
                class="cpld1img"
                src="@/common/images/productCenter/A3/cpld1.png"
                alt=""
              />
              <div class="text">
                <p class="text1">政策导航</p>
                <p class="text2">
                  解读行业利好，研判市场风口。梳理当前的政策方向和解读行业政策。
                </p>
              </div>
            </div>
            <div class="cpld1">
              <img
                class="cpld1img"
                src="@/common/images/productCenter/A3/cpld2.png"
                alt=""
              />
              <div class="text">
                <p class="text1">资金风向</p>
                <p class="text2">
                  追踪市场资金流向进行监测研究，洞察资金的主攻方向。
                </p>
              </div>
            </div>
          </div>
          <div class="cpld_s">
            <div class="cpld1">
              <img
                class="cpld1img"
                src="@/common/images/productCenter/A3/cpld3.png"
                alt=""
              />
              <div class="text">
                <p class="text1">产业乘风</p>
                <p class="text2">
                  深挖行业潜力，巧借产业东风。对市场环境以及行业细分领域进行深度分析。
                </p>
              </div>
            </div>
            <div class="cpld1">
              <img
                class="cpld1img"
                src="@/common/images/productCenter/A3/cpld4.png"
                alt=""
              />
              <div class="text">
                <p class="text1">策略破浪</p>
                <p class="text2">
                  根据模型，对行业中具有代表性的公司进行投资分析，助力投资者把握潜力板块的个股机会。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="demobox cpjs">
        <div class="boxin_cpjs">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>产品介绍</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b">
              先机所引
              <span style="display: inline-block; width: 20px"></span>
              觉醒元柱力
            </div>
          </div>
          <div class="cpjsd">
            <div class="cpjs1 js1">
              <p>加深投资者对政策、市场、行业、公司的认识了解</p>
              <p>把握潜力板块的投资机会</p>
              <p>打造稳健的投资逻辑</p>
            </div>
            <div class="cpjs1 js2">
              <p>培养良好的投资思维</p>
              <p>专业审慎，注重研发，结论有理有据</p>
              <p>
                信息数据都是可追溯、可回测的，验证检测投资过程中是否存在逻辑、策略、技术问题
              </p>
              <p>减少交易中主观臆测随意性的干扰</p>
            </div>
            <div class="cpjs1 js3">
              <p>专注于大类资产配置，在投资范围、创新空间的方面均十分灵活</p>
              <p>善于捕捉市场不同时期的投资机会，策略内容多元丰富</p>
              <p>
                主要以政策热点风口、市场资金流向为导向，为投资者提供专业市场研报分析
              </p>
              <p style="padding-right: 14px">
                帮追投资者更加合理的把握市场脉络，告别行情轮动下的市场盲点
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="ztcl">
        <div class="ztcl_boxin">
          <div class="ztcl_box">
            <div class="ztcl_l">
              <div class="titles">
                <div class="ztext">主</div>
                <div class="ztext">题</div>
                <div class="ztext">策</div>
                <div class="ztext">略</div>
              </div>
              <div class="ztcl_ms">
                以政策为导向，根据资金流向，深度剖析了产业发展，选取阶段时间里最具潜力行业板块的战略性投资报告。向投资者提供投资参考，掌握投资逻辑。
              </div>
              <div class="ztcl_t">四维全覆盖：</div>
              <div class="ztcl_icon">
                <div class="cards card1">
                  <img
                    src="../common/images/productCenter/A3/card1.png"
                    alt=""
                  />
                  <span>专业</span>
                </div>
                <div class="cards card2">
                  <img
                    src="../common/images/productCenter/A3/card2.png"
                    alt=""
                  />
                  <span>稳健</span>
                </div>
                <div class="cards card3">
                  <img
                    src="../common/images/productCenter/A3/card3.png"
                    alt=""
                  />
                  <span>成长</span>
                </div>
                <div class="cards card4">
                  <img
                    src="../common/images/productCenter/A3/card4.png"
                    alt=""
                  />
                  <span>共赢</span>
                </div>
              </div>
            </div>
            <div class="ztcl_r"></div>
          </div>
        </div>
      </div> -->
      <div class="tzbz">
        <div class="tzbzText">投资宝藏top：</div>

        <div class="tzbzbox">
          <div class="cards">
            <div class="card">
              <img src="../common/images/productCenter/A3/tzbz1.png" alt="" />
              <p>高价值成长行业</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/A3/tzbz2.png" alt="" />
              <p>热点风口爆发板块</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/A3/tzbz3.png" alt="" />
              <p>合理估值组合配置</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/A3/tzbz4.png" alt="" />
              <p>政策导向资金炒作</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/A3/tzbz5.png" alt="" />
              <p>把握A股战略性投资</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/A3/tzbz6.png" alt="" />
              <p>享短线题材研究报告</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inner" v-if="showNav.Big == 'DB' && showNav.small == 'b1'">
      <div class="demobox bigNav">
        <div class="boxin bigNavbox">
          <div
            class="NavD zx"
            v-on:click="BigNav('DA')"
            :class="showNav.Big == 'DA' ? 'isBnav' : ''"
          >
            <span>资讯产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DB')"
            :class="showNav.Big == 'DB' ? 'isBnav' : ''"
          >
            <span>投顾产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DC')"
            :class="showNav.Big == 'DC' ? 'isBnav' : ''"
          >
            <span>数据产品</span>
          </div>
        </div>
      </div>
      <div class="demobox banner bannerb1">
        <div class="boxin banmain videoDBbox">
          <video
            class="videoDB"
            id="videoDB"
            autoplay
            controls
            :src="videoDBsrc"
            type="video/mp4"
          ></video>
          <div class="play" v-if="palyDB" id="play" @click="DBplay">
            <img
              src="../common/images/productCenter/A1/paly.png"
              id="playbtn"
              class="playbtn"
              alt=""
            />
          </div>
          <img
            src="../common/images/productCenter/A1/palying.png"
            class="playing"
            v-if="playingB"
            alt=""
          />
        </div>
      </div>
      <div class="demobox smallNav">
        <div class="boxin smallNavbox DBsmallNav">
          <div
            class="Navd jy"
            v-on:click="SmaNav('b1')"
            :class="showNav.small == 'b1' ? 'isSnav' : ''"
          >
            大德精研
          </div>
          <div
            class="Navd zs"
            v-on:click="SmaNav('b2')"
            :class="showNav.small == 'b2' ? 'isSnav' : ''"
          >
            大德专属
          </div>
        </div>
      </div>
      <div class="demobox fwhx">
        <div class="fwhxbox">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span style="color: #fff">服务核心</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b" style="color: #b1c3eb">
              趋势为准
              <span
                style="display: inline-block; width: 20px; color: #b1c3eb"
              ></span>
              波段投资
            </div>
          </div>
          <div class="fwhx_cards">
            <img src="../common/images/productCenter/B1/fwhx1.png" alt="" />
            <img src="../common/images/productCenter/B1/fwhx2.png" alt="" />
            <img src="../common/images/productCenter/B1/fwhx3.png" alt="" />
          </div>
          <img
            class="fwicon"
            src="../common/images/productCenter/B1/fwicon.png"
            alt=""
          />
        </div>
      </div>
      <div class="demobox sdzyfw">
        <div class="boxin all">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>十大专业服务</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b">
              趋势为准
              <span style="display: inline-block; width: 20px"></span>
              波段投资
            </div>
          </div>
          <div class="careds careds1" style="margin-top: 36px">
            <div class="card">
              <img src="../common/images/productCenter/B1/sd1.png" alt="" />
              <p class="bi" style="color: #e7413b">精选个股组合</p>
              <p class="min min1">中短结合，波段操作</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/B1/sd2.png" alt="" />
              <p class="bi">专属投顾策略</p>
              <p class="min">洞悉资金流向，紧跟市场热点</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/B1/sd3.png" alt="" />
              <p class="bi">专属投顾规划</p>
              <p class="min">仓位管控，打造您的专属主题性投资</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/B1/sd4.png" alt="" />
              <p class="bi">股信解盘</p>
              <p class="min">投顾团队实时在线，答疑解惑</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/B1/sd5.png" alt="" />
              <p class="bi" style="width: 260px">中国股市证券投顾报告</p>
              <p class="min" style="width: 260px; padding: 0 0px">
                德讯周刊，解读一周个股动态与操盘心得
              </p>
            </div>
          </div>
          <div class="careds careds2" style="margin-top: -15px">
            <div class="card">
              <img src="../common/images/productCenter/B1/sd6.png" alt="" />
              <p class="bi">证券市场研究月报</p>
              <p class="min">解读短期政策红利，提前洞悉下月投资方向</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/B1/sd7.png" alt="" />
              <p class="bi">财富在线政策季刊</p>
              <p class="min">解密优质公司，深挖行业龙头</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/B1/sd8.png" alt="" />
              <p class="bi">证券投资年度报告</p>
              <p class="min">整合全年投资轨迹，把握后市投资机会</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/B1/sd9.png" alt="" />
              <p class="bi">交易师（精研投教）</p>
              <p class="min">授人以渔，专业投顾亲授投资技巧与实战经验</p>
            </div>
            <div class="card">
              <img src="../common/images/productCenter/B1/sd10.png" alt="" />
              <p class="bi">投顾团队在线诊股</p>
              <p class="min">专业投顾研习个股潜力，及时调仓换股，解套扭亏</p>
            </div>
          </div>
        </div>
      </div>
      <div class="demobox clbg">
        <div class="boxin all">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>策略报告</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
          </div>
          <div class="clbgbox">
            <div class="clbgbox_">
              <img
                class="clbgimg1"
                src="../common/images/productCenter/B1/clbgbox_1.png"
                alt=""
              />
            </div>
            <div class="clbgbox_">
              <img
                class="clbgimg2"
                src="../common/images/productCenter/B1/clbgbox_2.png"
                alt=""
              />
              <img
                class="clbgimg3"
                src="../common/images/productCenter/B1/clbgbox_3.png"
                alt=""
              />
            </div>
            <div class="clbgbox_">
              <img
                class="clbgimg4"
                src="../common/images/productCenter/B1/clbgbox_4.png"
                alt=""
              />
              <img
                class="clbgimg5"
                src="../common/images/productCenter/B1/clbgbox_5.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="demobox jyts">
        <div class="boxin all">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>精研特色</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
          </div>
          <div class="topcard">
            <div class="topcard1">
              <span class="topcardspan1">精研特点</span>
              <span class="topcardspan2">趋势为准，波段投资</span>
            </div>
            <div class="topcard2">
              <span class="topcardspan1">精研目标</span>
              <span class="topcardspan3">股市进阶型投资者</span>
              <span class="topcardspan4">追求高成长的长期投资方案</span>
            </div>
          </div>
          <div class="l_care">
            <div class="l_care_">
              <div class="care_to">
                <img
                  src="../common/images/productCenter/B1/jytsicon1.png"
                  alt=""
                />
                <span>操作风格</span>
              </div>
              <div class="l_b l_b1">
                <div class="p1">投资顾问精选，中短结合</div>
                <div class="p2">合理资产配置，科学把握投资价值</div>
              </div>
            </div>
            <div class="l_care_">
              <div class="care_to">
                <img
                  src="../common/images/productCenter/B1/jytsicon2.png"
                  alt=""
                />
                <span>策略体系</span>
              </div>
              <div class="l_b l_b2">
                <div class="p1">盘中操作提醒</div>
                <div class="p2">移动端专业投资顾问全程服务，在线答疑解惑</div>
                <div class="p1">投资顾问精选个股组合</div>
                <div class="p2">中短结合，把握个股未来动能</div>
              </div>
            </div>
          </div>
          <div class="r_care">
            <div class="care_to">
              <img
                src="../common/images/productCenter/B1/jytsicon3.png"
                alt=""
              />
              <span>投顾团队</span>
            </div>
            <div class="cares">
              <div class="cares_1">
                <div class="p1">股信解盘</div>
                <div class="p2">投顾团队实时在线，答疑解惑</div>
              </div>
              <div class="cares_1">
                <div class="p1">交易师(精研投教)</div>
                <div class="p2">投教视频解读投资技巧，专业视频解读投资机会</div>
              </div>
              <div class="cares_1">
                <div class="p1">投顾在线诊股</div>
                <div class="p2">专业投顾研习个股潜力</div>
              </div>
            </div>
            <div class="care_to">
              <img
                src="../common/images/productCenter/B1/jytsicon4.png"
                alt=""
              />
              <span>VIP专享服务</span>
            </div>
            <div class="cares">
              <div class="cares_2">
                <div class="p1">六重风控体系</div>
                <div class="p2">
                  合理管控规避风险（资金、技术、买卖区间、止盈止损及仓位、异动提示）
                </div>
              </div>
              <div class="cares_2">
                <div class="p1">精研投顾策略</div>
                <div class="p2">洞悉资金动向，预判个股潜力</div>
              </div>
              <div class="cares_2">
                <div class="p1">专属投顾规划</div>
                <div class="p2">仓位管理，打造您的专属主题性投资</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inner" v-if="showNav.Big == 'DB' && showNav.small == 'b2'">
      <div class="demobox bigNav">
        <div class="boxin bigNavbox">
          <div
            class="NavD zx"
            v-on:click="BigNav('DA')"
            :class="showNav.Big == 'DA' ? 'isBnav' : ''"
          >
            <span>资讯产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DB')"
            :class="showNav.Big == 'DB' ? 'isBnav' : ''"
          >
            <span>投顾产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DC')"
            :class="showNav.Big == 'DC' ? 'isBnav' : ''"
          >
            <span>数据产品</span>
          </div>
        </div>
      </div>
      <div class="demobox banner bannerb2">
        <div class="boxin banmain">
          <img src="@/common/images/productCenter/B2/banner.png" alt="" />
        </div>
      </div>
      <div class="demobox smallNav">
        <div class="boxin smallNavbox DBsmallNav">
          <div
            class="Navd jy"
            v-on:click="SmaNav('b1')"
            :class="showNav.small == 'b1' ? 'isSnav' : ''"
          >
            大德精研
          </div>
          <div
            class="Navd zs"
            v-on:click="SmaNav('b2')"
            :class="showNav.small == 'b2' ? 'isSnav' : ''"
          >
            大德专属
          </div>
        </div>
      </div>
      <div class="demobox sdtzfg" style="height: 598px">
        <div class="sdtzfgbox all">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span style="color: #fff">四大投资风格</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b" style="color: #bed2fb">
              行业龙头 + 深度追踪
            </div>
          </div>
          <div class="sdtzfgin">
            <img
              class="sdtzfgin_l"
              src="../common/images/productCenter/B2/sdtzfg1.png"
              alt=""
            />
            <div class="sdtzfgin_m">
              <img src="../common/images/productCenter/B2/sdtzfg2.png" alt="" />
            </div>
            <div class="sdtzfgin_r">
              <div class="sdtzfgin_r_ sdtzfgin_r1">
                <p style="margin-top: 92px">探寻价值拐点，解密投资真谛</p>
              </div>
              <div class="sdtzfgin_r_ sdtzfgin_r2">
                <p style="margin-top: 83px; width: 258px">
                  多元化配置，满足您的私人定制需求
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="demobox zstg">
        <div class="boxin all">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>专属投顾1V1服务</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b">多元化配置，满足您的私人定制需求</div>
          </div>
          <div class="zstgIner">
            <img
              class="zstgimg"
              src="../common/images/productCenter/B2/zstg.png"
              alt=""
            />
            <div class="zstgdom zstgdom1">
              <div class="p1">专属投顾策略</div>
              <div class="p2">
                专属投资顾问洞悉资金流向，紧跟市场热点，制定专属主题性投资策略
              </div>
            </div>
            <div class="zstgdom zstgdom2">
              <div class="p1">专属精选个股组合</div>
              <div class="p2">
                短线+中线+长线
                攻守兼备组合拳，热点+波段+趋势利润分配合理，六重风险管理，分散投资风险
              </div>
            </div>
            <div class="zstgdom zstgdom3">
              <div class="p1">专属投顾规划</div>
              <div class="p2">专属投资顾问仓位管控，打造您的专属投资计划</div>
            </div>
            <div class="zstgdom zstgdom4">
              <div class="p1">专属投顾股信解盘</div>
              <div class="p2">
                专属投资顾问实时解盘，极端行情操作提示，资产配比优化建议
              </div>
            </div>
            <div class="zstgdom zstgdom5">
              <div class="p1">专属投顾在线诊股</div>
              <div class="p2">
                专属投资顾问1V1实时在线解答个股潜力，梳理投资思路
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="demobox wdty">
        <div class="boxin">
          <div class="title">
            <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
            <span>五大投研专享</span>
            <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
          </div>
          <div class="wdtybox">
            <div class="wdtybox_">
              <img
                class="wdtyimg1"
                src="../common/images/productCenter/B2/wdtybox_1.png"
                alt=""
              />
            </div>
            <div class="wdtybox_">
              <img
                class="wdtyimg2"
                src="../common/images/productCenter/B2/wdtybox_2.png"
                alt=""
              />
              <img
                class="wdtyimg3"
                src="../common/images/productCenter/B2/wdtybox_3.png"
                alt=""
              />
            </div>
            <div class="wdtybox_">
              <img
                class="wdtyimg4"
                src="../common/images/productCenter/B2/wdtybox_4.png"
                alt=""
              />
              <img
                class="wdtyimg5"
                src="../common/images/productCenter/B2/wdtybox_5.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="inner" v-if="showNav.Big == 'DC'">
      <div class="demobox bigNav">
        <div class="boxin bigNavbox">
          <div
            class="NavD zx"
            v-on:click="BigNav('DA')"
            :class="showNav.Big == 'DA' ? 'isBnav' : ''"
          >
            <span>资讯产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DB')"
            :class="showNav.Big == 'DB' ? 'isBnav' : ''"
          >
            <span>投顾产品</span>
          </div>
          <div
            class="NavD tg"
            v-on:click="BigNav('DC')"
            :class="showNav.Big == 'DC' ? 'isBnav' : ''"
          >
            <span>数据产品</span>
          </div>
        </div>
      </div>
      <div class="topC1"></div>
      <div class="all">
        <div class="title">
          <div class="title-t">
            <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
            <span>人工诊股</span>
            <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
          </div>
          <div class="title-b" style="width: 628px; margin-bottom: 42px">
            豪华投资顾问团队坐镇亲自诊断分析股票，从基本面、资金面及技术面全方位提供专业诊断并附有短中长期详细的投顾分析。
          </div>
        </div>
        <div class="c1Tiele">
          专业投资顾问根据您持仓情况和当前个股实时走势，结合自身证券投顾经验，提供个股基本面、资金面、技术面及短中期走势投顾观点，助您证券投资中获得价值参考。
        </div>
        <div class="tyrgzg boxin" style="height: 862px">
          <div class="bline">
            <img src="../common/images/productCenter/A2/b1.png" alt="" />
            <img src="../common/images/productCenter/A2/bline1.png" alt="" />
            <img src="../common/images/productCenter/A2/b2.png" alt="" />
            <img src="../common/images/productCenter/A2/bline1.png" alt="" />
            <img src="../common/images/productCenter/A2/b3.png" alt="" />
          </div>
          <div class="btext">
            <span style="margin-left: 128px">选择投资顾问</span>
            <span style="margin-left: 213px">提交人工诊股</span>
            <span style="margin-left: 216px">人工诊股详情</span>
          </div>
          <div class="rgzg">
            <img src="../common/images/productCenter/C1/rgzg1.png" alt="" />
            <img src="../common/images/productCenter/C1/rgzg2.png" alt="" />
            <img src="../common/images/productCenter/C1/rgzg3.png" alt="" />
          </div>
        </div>
        <div class="jys">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>交易师</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b" style="width: 628px; margin-bottom: 42px">
              交易师为财富在线向用户提供的投资者教育视频，旨在通过专业投顾讲解股票投资技巧，让您获取投资知识提高投资水平
            </div>
          </div>
          <div class="jysL_Box">
            <div class="jysL">
              财富在线致力于为中国投资者孵化财富，为非专业投资人搭建学习平台和再投资通道。《交易师》独家投资者教学课程，精品课程教你分析市场，前言投资理论分析，授渔也授鱼。我们的使命是让每个股民都成为合格的投资者。
              <div class="jysR"></div>
            </div>
          </div>
          <div class="jysB"></div>
        </div>
        <!-- 股信 -->
        <div class="gux">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>股信</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b" style="width: 628px; margin-bottom: 42px">
              投顾团队和专属投顾在线解盘，实时盘中解疑答难，根据实时走势提供专业投顾分析，获取投顾服务像聊微信一样方便。
            </div>
          </div>
          <div class="gux_Box">
            <div class="gux_L"></div>
            <div class="gux_R">
              <div class="guxCard">
                <div class="guxCard1" style=""></div>
                <div class="guxCard2"></div>
                <div class="guxCard3">投顾团队实时解盘</div>
                <div class="guxCard4">
                  投顾团队紧跟市场变化，及时解读传递价值机会
                </div>
              </div>
              <div class="guxCard">
                <div class="guxCard11"></div>
                <div class="guxCard2"></div>
                <div class="guxCard3">专属投顾解盘</div>
                <div class="guxCard4">
                  专属投顾1对1投顾服务，丰厚证券投顾经验助您征途股海
                </div>
              </div>
              <div class="guxCard">
                <div class="guxCard111"></div>
                <div class="guxCard2"></div>
                <div class="guxCard3">风险提示</div>
                <div class="guxCard4">实时对行情研判及时进行风险提示</div>
              </div>
              <div class="guxCard">
                <div class="guxCard1111"></div>
                <div class="guxCard2"></div>
                <div class="guxCard3">主题性投资规划</div>
                <div class="guxCard4">
                  结合当前市场热点根据客户投资偏好制定专属主题性投资组合
                </div>
              </div>
            </div>
          </div>
          <div class="gux_b"></div>
        </div>
        <!-- 主题策略 -->
        <!-- 主题策略 -->
        <div class="jys">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>主题策略</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b" style="width: 628px; margin-bottom: 42px">
              以政策为导向、根据资金流向，深度剖析了产业发展，选取阶段时间里最具潜力行业板块的战略性投资报告。
            </div>
          </div>
          <div class="jysL_Box" style="margin-top: 60px">
            <div class="ztcl_L">
              <div class="ztcl1"></div>
            </div>
            <div class="ztcl_R"></div>
          </div>
          <div class="jysB"></div>
        </div>
        <!-- 股讯 -->
        <!-- 股讯 -->
        <div class="jys" style="background-color: #fff">
          <div class="title">
            <div class="title-t">
              <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
              <span>股讯</span>
              <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
            </div>
            <div class="title-b" style="width: 628px; margin-bottom: -42px">
              财富在线在第一时间呈现市场资讯、名师点评，为投资者提供准确、及时、具有前瞻性的决策支持，助您寻找价值投资机会。
            </div>
          </div>
          <div class="jysL_Box">
            <div class="jysL" id="guxun_r">
              <p>
                盘前提供德讯精研团队晨会纪要《战鼓擂·精研选股》，盘中提供热点题材板块跟踪，以及重要机会研判，盘后提供盘后快讯、市场数据观察、晚间解盘等。
              </p>
              <p>
                旨在给投资者提供全面、专业、及时的优质资讯，既有关于大盘走势的深入解读，也有热门板块和强势个股等精品内参分享，还有炒股经验、投资方法等超多炒股干货免费看。
              </p>

              <div class="jysR" id="guxun_l"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottoms @tiaozhaung="tiaozhaungS"></Bottoms>
  </div>
</template>

<script>
import topNav from "./sub/topNav";
import Bottoms from "./sub/Bottoms";
import { colunmList,productList,columnTypeList } from "@/api/topNav.js";
import { l } from "@/utils/tool";
export default {
  name: "productCenter",
  components: { topNav, Bottoms },
  data() {
    return {
      showNav: {
        Big: "DA",
        small: "a1",
      },
      videoDAsrc: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zb.mp4",
      videoDBsrc: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/jy.mp4",
      palyDA: true,
      palyDB: true,
      playingA: false,
      playingB: false,
      banners:[],
    };
  },
  mounted() {
    // window.scrollTo(0, 0);
    //     console.log(this.$route.params.id);
    // console.log(document.getElementById(this.$route.params.id));
    this.selectf();
    if (this.$route.params.id) {
      // document.getElementById(this.$route.params.id).scrollIntoView();
      window.scroll(
        0,
        document.getElementById(this.$route.params.id).offsetTop - 89
      );
    }

    var index = this.$route.query.index;
    if (index == 1) {
      this.showNav.Big = "DA";
      this.showNav.small = "a1";
    } else if (index == 2) {
      this.showNav.Big = "DA";
      this.showNav.small = "a2";
    } else if (index == 3) {
      this.showNav.Big = "DA";
      this.showNav.small = "a3";
    } else if (index == 4) {
      this.palyDB = false;
      this.playingB = true;

      this.showNav.Big = "DB";
      this.showNav.small = "b1";
    } else if (index == 5) {
      this.showNav.Big = "DB";
      this.showNav.small = "b2";
    } else if (index == 6) {
      this.showNav.Big = "DC";
    }

    if (this.showNav.Big == "DA" && this.showNav.small == "a1") {
      this.DAplayState();
    }
    if (this.showNav.Big == "DB" && this.showNav.small == "b1") {
      setTimeout(() => {
        this.DBplayState();
      }, 10);
    }
  },
  methods: {
    //大Nav
    BigNav: function (n) {
      this.showNav.Big = n;
      var that = this;
      if (n == "DA") {
        this.showNav.small = "a1";
        var s = setTimeout(function () {
          that.DAplayState();
          clearTimeout(s);
        }, 10);
      } else if (n == "DB") {
        this.showNav.small = "b1";
        var s = setTimeout(function () {
          that.DBplayState();
          clearTimeout(s);
        }, 10);
      }
    },
    //小Nav
    SmaNav: function (n) {
      this.showNav.small = n;
      var that = this;
      if (n == "a1") {
        var s = setTimeout(function () {
          that.DAplayState();
          clearTimeout(s);
        }, 10);
      }
      if (n == "b1") {
        var s = setTimeout(function () {
          that.DBplayState();
          clearTimeout(s);
        }, 10);
      }
    },
    //大德周报视频播放
    DAplay: function () {
      let video = document.getElementById("videoDA");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    DAplayState: function () {
      let that = this;
      let ele = document.getElementById("videoDA");
      ele.addEventListener("play", function () {
        //播放开始执行的函数
        //console.log(1);
        that.palyDA = false;
        that.playingA = true;
        let s = setTimeout(function () {
          that.playingA = false;
          clearTimeout(s);
        }, 1000);
      });
      ele.addEventListener("pause", function () {
        //暂停开始执行的函数
        //console.log(0);
        that.palyDA = true;
      });
    },
    //大德精研视频播放
    DBplay: function () {
      let video = document.getElementById("videoDB");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    DBplayState: function () {
      let that = this;
      let ele = document.getElementById("videoDB");
      console.log(ele);
      console.log(ele);
      console.log(ele.addEventListener);

      ele.addEventListener("play", function () {
        //播放开始执行的函数
        //console.log(1);
        that.palyDB = false;
        that.playingB = true;
        let s = setTimeout(function () {
          that.playingB = false;
          clearTimeout(s);
        }, 1000);
      });
      ele.addEventListener("pause", function () {
        //暂停开始执行的函数
        //console.log(0);
        that.palyDB = true;
      });
    },
    tiaozhaung: function (item) {
      if (item == "stockUniverse" || item == "investTeam") {
        this.$router.push(item);
      } else {
        this.$router.push({
          path: "/ddzb",
          query: {
            name: item,
          },
        });
      }
    },
    tiaozhaungS: function (item) {
      //子传父 在当前产品页点击
      if (item.name == "productCenter") {
        window.scroll(0, document.getElementById(item.id).offsetTop - 89);
      }
    },
    selectf(){
        colunmList({ column_name:'产品中心' }).then((res) => { //产品管理列表
        //列表
        if (res.code == 200 && res.data.list) {
          // l(res,'ds');
          this.banners = res.data.list[0].pictures.split(',');
        }
      });
    }
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  text-align: center;
}
.demobox {
  width: 1920px;
  height: 600px;
  margin: auto;
  overflow: hidden;
}
.inner {
  overflow: hidden;
}
.boxin {
  width: 1226px;
  /* overflow: hidden; */
  margin: 0 auto;
}
.bigNav {
  height: 496px;
}
.bigNav .bigNav-img {
    width: 100%;
    max-width: 1920px;
    height: 496px !important;
    margin: auto;
}
.bigNavbox {
  width: 1226px;
  height: 88px;
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  justify-content: space-between;
  padding: 0 108px;
  box-sizing: border-box;
  z-index: 5;
}
.bannerMain {
  width: 100%;
  height: 100%;
}
.bannerMain >>> .el-carousel__container {
  width: 100%;
  height: 496px !important;
}
.NavD {
  width: 400px;
  height: 100%;
  z-index: 10;
  box-sizing: border-box;
  cursor: pointer;
}
.NavD span {
  display: block;
  width: 136px;
  height: 48px;
  margin: 0 auto;
  margin-top: 30px;
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #888;
  opacity: 1;
}
.NavD span:hover {
  color: #e7413b;
}
.isBnav {
  border-bottom: 2px solid #e7413b;
}
.isBnav span {
  color: #e7413b;
}
.banner {
  width: 1920px;
  height: 600px;
  margin: auto;
}
.wenzi {
  position: absolute;
  right: 27%;
  bottom: 38%;
}
.tougu {
  position: absolute;
  right: 61.3%;
  bottom: 29%;
}
.tougu a {
  color: #dfb283 !important;
  border-bottom: 1px solid #dfb283 !important;
}
.shift {
  right: 34.5% !important;
  bottom: 38% !important;
}
.wenzi a {
  color: #228efb;
  font-size: 18px;
  font-weight: 600;
  margin-right: 50px;
  border-bottom: 1px solid #228efb;
  padding-bottom: 4px;
}
.wenzi a:hover {
  cursor: pointer;
}
.bannera1 {
  /* background: url("../common/images/productCenter/A1/bannerback.png") no-repeat; */
  background: url("../common/images/productCenter/A1/ddhj2.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.bannera2 {
  background: url("../common/images/productCenter/A2/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.bannera3 {
  background: url("../common/images/productCenter/A3/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.bannerb1 {
  background: url("../common/images/productCenter/B1/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.bannerb2 {
  background: url("../common/images/productCenter/B2/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.banmain {
  height: 460px;
}
.smallNav {
  position: relative;
}
.wenzi2 {
  position: absolute;
  right: 58.9%;
  bottom: 28%;
}
.wenzi2 a {
  color: #ff4b4f;
  font-size: 18px;
  font-weight: 600;
  margin-right: 50px;
  border-bottom: 1px solid #ff4b4f;
  padding-bottom: 4px;
}
.wenzi2 a:hover {
  cursor: pointer;
}
.smallNavbox {
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
  padding-bottom: 47px;
}
.Navd {
  width: 374px;
  height: 82px;
  background-color: #f5f5f5;
  border-radius: 6px;
  text-align: center;
  line-height: 82px;
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #888888;
  cursor: pointer;
}
.Navd:hover {
  color: #e7413b;
}
.isSnav {
  background: url("../common/images/productCenter/A1/isSnav.png") no-repeat;
  background-size: 100% 100%;
  color: #fff;
}
.isSnav:hover {
  color: #fff;
}
.all .title {
  width: 100%;
  margin-top: 60px;
}
.all .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.all .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.all .title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}

/* 资讯产品-大德周报 */
.zbbox {
  width: 1226px;
  height: 623px;
  margin: 0 auto;
}
.zblongbox {
  width: 1500px;
  overflow: hidden;
}
.videoDAbox,
.videoDBbox {
  position: relative;
}
.videoDA,
.videoDB {
  height: 460px;
}
.videoDAbox .play,
.videoDBbox .play {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 400px;
  background: linear-gradient(rgba(80, 80, 80, 0.3), rgba(80, 80, 80, 0));
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}
.videoDAbox .playbtn,
.videoDBbox .playbtn {
  display: block;
  width: 90px;
  height: 90px;
  margin-top: 30px;
}
.videoDAbox .playing,
.videoDBbox .playing {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -45px;
  margin-top: -60px;
}
.zb_l {
  width: 645px;
  margin-right: 17px;
  float: left;
  padding-top: 53px;
}
.zb_r {
  width: 647px;
  float: left;
}
.zb_l .text p {
  width: 100%;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #333333;
  opacity: 1;
  text-align: left;
}
.zb_l .linebtn {
  display: block;
  margin: 0 auto;
  margin-top: 22px;
  margin-bottom: 23px;
}
.zb_l .icons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 9px;
  box-sizing: border-box;
}
.zb_l .icons img {
  width: 70px;
  height: 80px;
}
.zb_l .icons img:nth-child(even) {
  height: 1px;
}
.zb_l .icontext {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.zb_l .icontext span {
  display: block;
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 33px;
  color: #666666;
  opacity: 1;
}
.px {
  /* height: 880px; */
  /* background: url("../common/images/productCenter/A1/b1786.png") no-repeat; */
  background-size: 100% 100%;
}
.px .title {
  width: 100%;
  margin-top: 60px;
  margin-bottom: 54px;
}
.px .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.px .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.px .title-b {
  width: 144px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 1;
  margin: 0 auto;
  margin-top: 4px;
}
.px .cars {
  display: flex;
  flex-wrap: wrap;
  width: 1300px;
  margin: 0 auto;
}
.px .car {
  position: relative;
  float: left;
  width: 580px;
  height: 200px;
  box-sizing: border-box;
  display: flex;
  /* justify-content: space-between; */
  background: #ffffff;
  border: 1px solid #c5c5c5;
  border-radius: 4px 4px 4px 4px;
  margin-bottom: 24px;
}
.carLine {
  position: absolute;
  top: 106px;
  left: 164px;
  width: 68px;
  height: 0px;
  opacity: 1;
  border: 1px solid #e5e5e5;
}
.car:nth-child(2n -1) {
  margin-left: 20px;
}
.car:nth-child(2n) {
  margin-left: 24px;
}
.px .car_l {
  height: 84px;
  width: 84px;
  margin-top: 58px;
  margin-left: 40px;
}
.px .car_r {
  height: 100%;
  margin-left: 40px;
}
.px .car_r p:nth-child(2n -1) {
  width: 400px;
  font-size: 30px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #dc3221;
  margin-bottom: 28px;
  position: relative;
  text-align: left;
}
.px .car_r p:nth-child(2n) {
  width: 400px;
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: 400;
  color: #4e4e4e;
  line-height: 26px;
  margin-bottom: 14px;
  position: relative;
  text-align: left;
}
/* .px .car_r p::before {
  content: "";
  position: absolute;
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #d2d2d2;
  top: 10px;
  left: -10px;
} */

.look10 {
  height: 752px;
  background: #fff;
}
.look10box {
  width: 1500px;
  overflow: hidden;
  margin: 0 auto;
}
.look10 .title {
  width: 100%;
  margin-top: 60px;
  margin-bottom: 54px;
}
.look10 .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.look10 .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.look10 .title-b {
  width: 144px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 1;
  margin: 0 auto;
  margin-top: 4px;
}
.look10 .cara1 {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.look10 .cara11 {
  overflow: hidden;
  margin-bottom: 50px;
  width: 262px;
}
.look10 .cara11 img {
  display: block;
  margin: 0 auto;
}
.look10 .cara11 .cara11p1 {
  width: 100%;
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 33px;
  color: #333333;
  opacity: 1;
  margin-top: 14px;
  margin-bottom: 10px;
  text-align: center;
}
.look10 .cara11 .cara11p2 {
  width: 100%;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 1;
  text-align: center;
}

/* 资讯产品-人工诊股 */
/* @/common/images/productCenter/A1/fm.png */
.smallNavbox2 {
  padding-bottom: 68px;
}
.zgbox {
  width: 1226px;
  height: 637px;
  margin: 0 auto;
}
.zglongbox {
  width: 1500px;
  overflow: hidden;
}
.zg_l {
  width: 730px;
  margin-right: 41px;
  float: left;
  padding-top: 48px;
}
.zg_r {
  width: 537px;
  float: left;
}
.zg_l .text p {
  width: 100%;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #333333;
  opacity: 1;
  text-align: left;
}
.zg_1 {
  width: 552px;
  height: 46px;
  background: rgba(255, 255, 255, 0.39);
  border: 1px solid #ffdddb;
  opacity: 1;
  border-radius: 4px;
  display: flex;
  justify-content: left;
}
.zg_1 p {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
  color: #fd544e;
  opacity: 1;
  text-indent: 1em;
}
.zg_11 {
  margin-top: 48px;
}
.zg_12 {
  margin-top: 16px;
}
.zgts {
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 33px;
  color: #333333;
  opacity: 1;
  margin-top: 52px;
  margin-bottom: 44px;
  text-align: left;
}
.zgicons {
  width: 574px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 63px;
}
.zgtext {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}
.zgtext span {
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 28px;
  color: #666666;
  opacity: 1;
}
.zgld {
  height: 610px;
  background: url("../common/images/productCenter/A2/b1850.png") no-repeat;
  background-size: 100% 100%;
}
.zgld .title {
  width: 100%;
  margin-top: 60px;
  margin-bottom: 54px;
}
.zgld .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.zgld .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #fff;
  opacity: 1;
  margin: 0 50px;
}
.zgld .title-b {
  width: 144px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #ffffff;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
.zgld .cards {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.zgld .card {
  width: 313px;
  height: 366px;
}
.zgld .card p {
  width: 205px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #666666;
  opacity: 1;
  margin: 0 auto;
  margin-top: 204px;
  text-align: left;
}
.zgld .card1 {
  background: url("../common/images/productCenter/A2/card1.png") no-repeat;
  background-size: 100% 100%;
}
.zgld .card2 {
  background: url("../common/images/productCenter/A2/card2.png") no-repeat;
  background-size: 100% 100%;
}
.zgld .card3 {
  background: url("../common/images/productCenter/A2/card3.png") no-repeat;
  background-size: 100% 100%;
}
.zgld .card4 {
  background: url("../common/images/productCenter/A2/card4.png") no-repeat;
  background-size: 100% 100%;
}

.tyrgzg {
  height: 973px;
}
.tyrgzg .title {
  width: 100%;
  margin-top: 60px;
  margin-bottom: 54px;
}
.tyrgzg .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.tyrgzg .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.tyrgzg .title-b {
  width: 144px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
.tyrgzg .bline {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  margin-bottom: 21px;
}

.tyrgzg .bline img:nth-child(2n) {
  margin: 0 60px;
}
.tyrgzg .btext {
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
}
.tyrgzg .btext span {
  display: block;
  height: 42px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 42px;
  color: #333333;
  opacity: 1;
}

.tyrgzg .b1860 {
  position: relative;
  width: 1504px;
  top: 0px;
  left: -194px;
}
/* 资讯产品-主题策略 */
.cpld {
  height: 680px;
  /* background: url("../common/images/productCenter/A3/b1862.png") no-repeat; */
  background-size: 100% 100%;
}
.cpld .title {
  width: 100%;
  margin-top: 60px;
  margin-bottom: 44px;
}
.cpld .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cpld .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.cpld .title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
.cpld_mid {
  width: 100%;
  height: 129px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 129px;
  color: #e7413b;
  opacity: 1;
  text-align: center;
  background: url("../common/images/productCenter/A3/b1863.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 40px;
}
.cpld_line {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 22px;
}
.cpld_line hr {
  width: 594px;
  height: 0px;
  border-bottom: 1px solid #d5d5d5;
  opacity: 0.3;
}
.cpld_line span {
  display: block;
  width: 7px;
  height: 7px;
  background: rgba(213, 213, 213, 0.9);
  border-radius: 50%;
  opacity: 1;
}
.cpld_s {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cpld1 {
  margin-bottom: 30px;
  overflow: hidden;
}
.cpld1 .cpld1img {
  display: block;
  float: left;
}
.cpld1 .text {
  display: block;
  float: left;
  width: 440px;
}
.cpld1 .text1 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 33px;
  color: #e7413b;
  opacity: 1;
  text-align: left;
  margin-left: 20px;
  margin-top: 10px;
}
.cpld1 .text2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #666666;
  opacity: 1;
  text-align: left;
  margin-left: 20px;
  margin-top: 19px;
}

.boxin_cpjs {
  width: 1226px;
  margin: 0 auto;
}
.cpjs {
  height: 699px;
  background: url("../common/images/productCenter/A3/a3BJ.png") no-repeat;
  background-size: 100% 100%;
}
.cpjs .title {
  width: 100%;
  margin-top: 60px;
  margin-bottom: 50px;
}
.cpjs .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cpjs .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.cpjs .title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
.cpjsd {
  width: 1500px;
  overflow: hidden;
}
.cpjs1 {
  float: left;
  margin-right: 62px;
  height: 447px;
  padding-left: 46px;
  padding-right: 31px;
  padding-top: 129px;
  box-sizing: border-box;
}
.cpjs1 p {
  width: 100%;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #666666;
  text-align: left;
  margin-bottom: 12px;
  opacity: 1;
  position: relative;
}
.cpjs1 p::before {
  content: "";
  position: absolute;
  left: -20px;
  top: 10px;
  width: 10px;
  height: 10px;
  background-color: #f4ddc7;
  border-radius: 50%;
  opacity: 1;
}

.js1 {
  width: 366px;
  background: url("../common/images/productCenter/A3/cpjs1.png") no-repeat;
  background-size: 100% 100%;
}
.js2 {
  width: 367px;
  background: url("../common/images/productCenter/A3/cpjs2.png") no-repeat;
  background-size: 100% 100%;
}
.js3 {
  width: 388px;
  background: url("../common/images/productCenter/A3/cpjs3.png") no-repeat;
  background-size: 100% 100%;
  padding-right: 54px;
}
.ztcl {
  width: 100%;
  height: 620px;
  background: linear-gradient(314deg, #4652fe 0%, #228efb 100%);
  opacity: 1;
}
.ztcl_boxin {
  width: 1226px;
  margin: 0 auto;
}
.ztcl_box {
  width: 1500px;
  height: 620px;
  position: relative;
}
.tzbz_title {
  position: absolute;
  bottom: -87px;
  height: 0;
}
.ztcl_l {
  width: 613px;
  height: 100%;
  overflow: hidden;
  margin-right: 30px;
  float: left;
}
/* .ztcl_r {
  overflow: hidden;
  float: left;
  width: 710px;
  height: 649px;
  margin-top: 39px;
  background: url("../common/images/productCenter/A3/ztcl.png") no-repeat;
  background-size: 100% 100%;
} */
.titles {
  width: 100%;
  overflow: hidden;
}
.ztext {
  width: 96px;
  height: 96px;
  float: left;
  margin-right: 25px;
  margin-top: 60px;
  background: url("../common/images/productCenter/A3/k1463.png") no-repeat;
  background-size: 100% 100%;

  font-size: 56px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 96px;
  color: #ffffff;
  opacity: 1;
}
.ztcl_ms {
  width: 100%;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
  color: #ffffff;
  opacity: 0.88;
  margin-top: 28px;
  text-align: left;
}
.ztcl_t {
  width: 100%;
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 37px;
  color: #ffffff;
  opacity: 1;
  margin-top: 41px;
  text-align: left;
}
.ztcl_icon {
  width: 100%;
  overflow: hidden;
  margin-top: 24px;
}
.ztcl_icon .cards {
  width: 62px;
  float: left;
  margin-right: 72px;
}
.ztcl_icon img {
  display: block;
}
.ztcl_icon span {
  display: block;
  width: 100%;
  height: 33px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 33px;
  color: #f3f7ff;
  margin-top: 8px;
  opacity: 1;
}
.tzbz {
  position: relative;
  width: 100%;
  height: 324px;
  padding-top: 41px;
  overflow: hidden;
}
.tzbzText {
  position: absolute;
  top: 40px;
  left: 347px;
  height: 42px;
  font-size: 30px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
}
.tzbzbox {
  width: 1226px;
  margin: 0 auto;
  overflow: hidden;
}
.tzbz_title {
  width: 100%;
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 37px;
  color: #333333;
  opacity: 1;
  text-align: left;
}
.tzbz .cards {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 79px;
}
.tzbz .card {
  overflow: hidden;
}
.tzbz .card img {
  display: block;
  margin: 0 auto;
}
.tzbz .card p {
  margin-top: 14px;
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 28px;
  color: #333333;
  opacity: 1;
}
/* 投顾产品-大德精研 */
.DBsmallNav {
  padding: 0 80px;
  padding-top: 30px;
  padding-bottom: 20px;
  position: relative;
  box-sizing: border-box;
}
.fwhx {
  width: 100%;
  height: 550px;
  overflow: hidden;
  background: url("../common/images/productCenter/B1/y1.png") no-repeat;
  background-size: 100% 100%;

  position: relative;
}

.fwhx .fwicon {
  position: absolute;
  left: 127px;
  top: 159px;
}
.fwhxbox {
  position: relative;
  width: 1500px;
  height: 550px;
  overflow: hidden;
  margin: 0 auto;
}
.fwhx .title {
  width: 100%;
  margin-top: 60px;
}
.fwhx .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.fwhx .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.fwhx .title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
.fwhx_cards {
  width: 748px;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  margin-left: 644px;
  position: relative;
  z-index: 10;
}
.fwhx_cards img {
  display: inline-block;
}
.sdzyfw {
  width: 100%;
  height: 730px;
}
.sdzyfw .careds {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.sdzyfw .careds .card {
  width: 234px;
  height: 262px;
  /* background: #fafafa; */
  opacity: 1;
  border-radius: 4px;
}
.sdzyfw .careds .card img {
  margin: 0 auto;
  margin-top: 28px;
}
.sdzyfw .careds .card .bi {
  display: block;
  margin-top: 20px;
  width: 100%;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 28px;
  color: #333333;
  opacity: 1;
}
.sdzyfw .careds .card .min {
  width: 100%;
  font-size: 16px;
  padding: 0 10px;
  box-sizing: border-box;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 1;
  margin-top: 10px;
  text-align: left;
}
.sdzyfw .careds .card .min1 {
  text-align: center;
}
.careds1 {
  margin-top: 40px;
}
.careds2 {
  margin-top: 14px;
}
.clbg {
  height: 760px;
  overflow: hidden;
  background: url("../common/images/productCenter/B1/b1785.png") no-repeat;
  background-size: 100% 100%;
}
.clbgbox {
  display: flex;
  justify-content: space-between;
  margin-top: 46px;
}
.clbgbox .clbgbox_ {
  width: 408px;
  height: 100%;
  float: left;
  overflow: hidden;
}
.clbgimg1 {
  margin-left: -115px;
  margin-top: -57px;
}
.clbgimg2 {
  margin-left: -1px;
  margin-top: -0;
}
.clbgimg3 {
  margin-left: -1px;
  margin-top: 8px;
}
.clbgimg4 {
  margin-left: -2px;
  margin-top: 0;
}
.clbgimg5 {
  margin-left: -2px;
  margin-top: 8px;
}
.jyts {
  height: 845px;
}
.topcard {
  width: 100%;
  margin-top: 50px;
  overflow: hidden;
}
.topcard1 {
  width: 478px;
  height: 57px;
  background: url("../common/images/productCenter/B1/jytst1.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 20px;
  float: left;
}
.topcard2 {
  width: 728px;
  height: 57px;
  background: url("../common/images/productCenter/B1/jytst2.png") no-repeat;
  background-size: 100% 100%;
  float: left;
}
.topcard span {
  display: inline-block;
  float: left;
}
.topcard .topcardspan1 {
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 37px;
  color: #3366ff;
  opacity: 1;
  margin-top: 10px;
  margin-left: 53px;
}
.topcard .topcardspan2 {
  width: 198px;
  height: 30px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #666666;
  opacity: 1;
  margin-top: 14px;
  margin-left: 73px;
}
.topcard .topcardspan3 {
  width: 176px;
  height: 30px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 30px;
  color: #666666;
  opacity: 1;
  margin-top: 14px;
  margin-left: 73px;
}
.topcard .topcardspan4 {
  width: 264px;
  height: 30px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #666666;
  opacity: 1;
  margin-top: 14px;
  margin-left: 8px;
}
.jyts .care_to {
  display: flex;
  justify-content: left;
  margin-bottom: 20px;
}
.jyts .care_to img {
  margin-right: 14px;
}
.jyts .care_to span {
  display: block;
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 37px;
  color: #333333;
  opacity: 1;
}
.l_care {
  width: 452px;
  margin-top: 43px;
  float: left;
}
.jyts .l_b {
  width: 452px;
  opacity: 1;
  border-radius: 4px;
  margin-top: 20px;
  overflow: hidden;
}
.jyts .l_b1 {
  height: 122px;
}
.jyts .l_b2 {
  height: 198px;
}
.jyts .l_b .p1 {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 30px;
  color: #444;
  opacity: 1;
  text-align: left;
  margin-top: 29px;
  margin-left: 47px;
}
.jyts .l_b .p2 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #888;
  opacity: 0.82;
  text-align: left;
  margin-top: 12px;
  margin-left: 47px;
}
.jyts .l_b1 {
  background: url("../common/images/productCenter/B1/l_b1.png") no-repeat;
  background-size: 100% 100%;
}
.jyts .l_b2 {
  background: url("../common/images/productCenter/B1/l_b2.png") no-repeat;
  background-size: 100% 100%;
}
.jyts .l_b2 .p1 {
  margin-top: 24px;
  position: relative;
}
.jyts .l_b2 .p2 {
  margin-top: 12px;
  position: relative;
}
.jyts .l_b2 .p1::before {
  content: "";
  position: absolute;
  left: -23px;
  top: 10px;
  width: 12px;
  height: 12px;
  background: rgba(230, 230, 230, 1);
  border-radius: 50%;
  opacity: 1;
}
.l_care_ {
  margin-bottom: 47px;
}
.r_care {
  width: 654px;
  float: left;
  overflow: hidden;
  margin-top: 43px;
  margin-left: 120px;
}
.cares {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 47px;
}
.cares_1 {
  background: url("../common/images/productCenter/B1/jytstz.png") no-repeat;
  background-size: 100% 100%;
  width: 210px;
  height: 140px;
  overflow: hidden;
}
.cares_1 .p1 {
  width: 100%;
  height: 30px;
  font-size: 22px;
  font-family: PingFang SC;

  font-weight: bold;
  line-height: 30px;
  color: #db3220;
  opacity: 1;
  margin: 0 auto;
  margin-top: 15px;
}
.cares_1 .p2 {
  width: 176px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 26px;
  color: #666666;
  opacity: 1;
  margin: 0 auto;
  margin-top: 27px;
  text-align: left;
}
.cares_2 {
  background: url("../common/images/productCenter/B1/jytsth.png") no-repeat;
  background-size: 100% 100%;
  width: 210px;
  height: 180px;
  overflow: hidden;
}
.cares_2 .p1 {
  width: 100%;
  height: 30px;
  font-size: 22px;
  font-family: PingFang SC;

  font-weight: bold;
  line-height: 30px;
  color: #632806;
  opacity: 1;
  margin: 0 auto;
  margin-top: 15px;
}
.cares_2 .p2 {
  width: 167px;
  height: 100px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 26px;
  color: #666666;
  opacity: 1;
  margin: 0 auto;
  margin-top: 27px;
  text-align: left;
}
/* 投顾产品-大德专属 */
.sdtzfg {
  height: 630px;
  background: url("../common/images/productCenter/B2/sdtzfg.png") no-repeat;
  background-size: 100% 100%;
}
.sdtzfgbox {
  width: 1226px;
  margin: 0 auto;
}
.sdtzfgin {
  width: 1500px;
  height: 420px;
  position: relative;
  margin-top: 34px;
}
.sdtzfgin_l {
  /* display: block;
  margin-left: -18px;
  margin-top: -11px;
  float: left;
  margin-right: 76px; */
  position: absolute;
  top: -32px;
  left: -86px;
}
.sdtzfgin_m {
  /* float: left; */
  position: absolute;
  top: 7px;
  left: 460px;
}
.sdtzfgin_r {
  /* float: left;
  margin-left: 14px; */
  position: absolute;
  top: 7px;
  left: 907px;
}
.sdtzfgin_r_ {
  overflow: hidden;
}
.sdtzfgin_r1 {
  width: 306px;
  height: 171px;
  background: url("../common/images/productCenter/B2/b1915.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 14px;
  margin-top: 0px;
}
.sdtzfgin_r2 {
  width: 306px;
  height: 171px;
  background: url("../common/images/productCenter/B2/b1916.png") no-repeat;
  background-size: 100% 100%;
}

.sdtzfgin_r_ p {
  margin: 0 auto;
  margin-top: 101px;
  width: 260px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 32px;
  color: #666666;
  text-align: left;
  opacity: 1;
}

.zstg {
  height: 766px;
}
.zstgIner {
  position: relative;
  height: 668px;
}
.zstgimg {
  position: absolute;
  top: 93px;
  left: 407px;
}
.zstgdom {
  position: absolute;
  overflow: hidden;
}
.zstgdom .p1 {
  height: 37px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 600;
  line-height: 37px;
  color: #e7413b;
  opacity: 1;
  text-align: left;
}
.zstgdom .p2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 32px;
  color: #666666;
  opacity: 1;
  margin-top: 8px;
  text-align: left;
}
.zstgdom1 {
  left: 28px;
  top: 140px;
}
.zstgdom1 .p2 {
  width: 367px;
}
.zstgdom2 {
  left: 16px;
  top: 412px;
}
.zstgdom2 .p2 {
  width: 413px;
}
.zstgdom3 {
  left: 716px;
  top: 37px;
}
.zstgdom3 .p2 {
  width: 420px;
}
.zstgdom4 {
  left: 879px;
  top: 235px;
}
.zstgdom4 .p2 {
  width: 334px;
}
.zstgdom5 {
  left: 765px;
  top: 463px;
}
.zstgdom5 .p2 {
  width: 439px;
}
.wdty {
  height: 788px;
  background: url("../common/images/productCenter/B2/wdty.png") no-repeat;
  background-size: 100% 100%;
}
.wdty .title {
  width: 100%;
  height: 56px;
  margin-top: 60px;
  margin-bottom: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wdty .title span {
  width: 240px;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 20px;
}
.wdty .title .hr {
  width: 160px;
  border: 0;
  height: 1px;
  background: #cecece;
  opacity: 1;
}

.wdtybox {
  display: flex;
  justify-content: space-between;
  margin-top: 46px;
}
.wdtybox .wdtybox_ {
  width: 408px;
  height: 100%;
  float: left;
  overflow: hidden;
}

.wdtyimg3 {
  margin-top: 8px;
}
.wdtyimg5 {
  margin-top: 8px;
}
/* C1 */
.topC1 {
  width: 100%;
  height: 604px;
  background: url("../common/images/productCenter/C1/top.png") no-repeat;
  background-size: 100% 100%;
}
.c1Tiele {
  box-sizing: border-box;
  width: 1090px;
  height: 141px;
  background: url("../common/images/productCenter/C1/c1Tiele.png") no-repeat;
  background-size: 100% 100%;
  margin: 55px auto 30px;
  padding: 30px 38px;
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ce251d;
  line-height: 50px;
  text-align: left;
}
.rgzg {
  display: flex;
  justify-content: space-between;
  width: 1090px;
  margin: 20px auto 50px;
}
.jys {
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 915px;
  background: #f4f4f4;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin: 0 auto;
}
.jysL_Box {
  display: flex;
  width: 1226px;
  height: 615px;
  margin: 114px auto 0;
}
.jysL {
  box-sizing: border-box;
  position: relative;
  height: 615px;
  width: 539px;
  font-size: 26px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 48px;
  padding: 40px 78px 0 70px;
  background: url("../common/images/productCenter/C1/jysL.png") no-repeat;
  background-size: 100% 100%;
  text-align: left;
}
.jysR {
  position: absolute;
  top: -52px;
  left: 538px;
  width: 668px;
  height: 660px;
  background: url("../common/images/productCenter/C1/jysR.png") no-repeat;
  background-size: 100% 100%;
  z-index: 9;
}
.jysB {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 317px;
  background: url("../common/images/productCenter/C1/jysB.png") no-repeat;
  background-size: 100% 100%;
}
.gux {
  position: relative;
  width: 100%;
  height: 915px;
  margin: 0 auto;
}
.gux_Box {
  display: flex;
  width: 1226px;
  height: 615px;
  margin: 60px auto 0;
}
.gux_L {
  width: 668px;
  height: 660px;
  background: url("../common/images/productCenter/C1/gux1.png") no-repeat;
  background-size: 100% 100%;
  z-index: 9;
}
.gux_R {
  padding: 86px 0 0 56px;
  z-index: 9;
}
.guxCard {
  position: relative;
  width: 464px;
  height: 84px;
  margin-bottom: 46px;
}
.guxCard1 {
  position: absolute;
  top: 9px;
  width: 70px;
  height: 66px;
  background: url("../common/images/productCenter/C1/gux2.png") no-repeat;
  background-size: 100% 100%;
}
.guxCard11 {
  position: absolute;
  top: 3px;
  width: 70px;
  height: 82px;
  background: url("../common/images/productCenter/C1/gux3.png") no-repeat;
  background-size: 100% 100%;
}
.guxCard111 {
  position: absolute;
  top: 3px;
  width: 70px;
  height: 86px;
  background: url("../common/images/productCenter/C1/gux4.png") no-repeat;
  background-size: 100% 100%;
}
.guxCard1111 {
  position: absolute;
  width: 70px;
  height: 77px;
  background: url("../common/images/productCenter/C1/gux5.png") no-repeat;
  background-size: 100% 100%;
}
.guxCard2 {
  position: absolute;
  top: 12px;
  left: 105px;
  width: 14px;
  height: 14px;
  background: url("../common/images/productCenter/C1/gux6.png") no-repeat;
  background-size: 100% 100%;
}
.guxCard3 {
  text-align: left;
  position: absolute;
  top: 0;
  left: 129px;
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
}
.guxCard4 {
  position: absolute;
  top: 44px;
  left: 105px;
  text-align: left;
  width: 358px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
.gux_b {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 317px;
  background: url("../common/images/productCenter/C1/guxB.png") no-repeat;
  background-size: 100% 100%;
}
.ztcl_L {
  position: relative;
  width: 530px;
  height: 666px;
  background: url("../common/images/productCenter/C1/ztcl1.png") no-repeat;
  background-size: 100% 100%;
  z-index: 9;
}
.ztcl_R {
  margin: 6px 0 0 28px;
  width: 668px;
  height: 660px;
  background: url("../common/images/productCenter/C1/ztcl2.png") no-repeat;
  background-size: 100% 100%;
  z-index: 9;
}
.ztcl1 {
  position: absolute;
  top: 27px;
  left: 55px;
  width: 420px;
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffe2e2;
  line-height: 46px;
  text-align: left;
}
.jysL > p {
  text-align: left;
}
#guxun_r {
  width: 508px;
  height: 618px;
  margin-left: 708px;
  background: url("../common/images/productCenter/C1/guxun_r.png") no-repeat;
  padding: 55px 74px 0 64px;
  text-align: left;
}
#guxun_l {
  top: -16px;
  left: -708px;
  width: 668px;
  height: 660px;
  background: url("../common/images/productCenter/C1/guxun_l.png") no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter.vue